import React, { useMemo } from "react";
import { getSizedImageUrl } from "@shopify/theme-images";

const Image = (data) => {
  const {
    alt = "",
    height,
    maxWidth,
    src = data.cloudinary_src,
    cloudinary_src = null,
    width,
  } = data;

  if (!src) return null;
  const imageSrc = src.includes("aws") ? src : getSizedImageUrl(src, "750x");

  const buildSrcset = () => {
    const componentMaxWidth = Math.min(width, maxWidth);
    const widths = [200, 375, 750, 1100, 1500, 1780, 2000, 2800].filter(
      (w) => w <= componentMaxWidth
    );
    return widths
      .map((w) =>
        !!cloudinary_src ? `${src}&w=${w} ${w}w` : `${getSizedImageUrl(src, `${w}x`)} ${w}w`
      )
      .join(",");
  };

  const image = useMemo(
    () => (
      <img
        srcSet={buildSrcset()}
        src={!!cloudinary_src ? `${src}&w=750` : imageSrc}
        loading="lazy"
        alt={alt}
        width={width}
        height={height}
      />
    ),
    [data]
  );

  return image;
};

export default Image;
